import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import Topbar from "../../../components/Topbar/Topbar";
import { Table } from "../../../components/Table/Table";
import {
  delete_icon,
  dummyimage,
  edit_icon,
  Search_icon,
} from "../../../assets/img";
import HighlightOffRoundedIcon from "@mui/icons-material/HighlightOffRounded";
import { get, post } from "../../../Services/ApiHandler";
import { URLS } from "../../../Services/Constant";
import { toast } from "react-toastify";
import { checkPermission } from "../../redux/api/PermissionManager";

const BookingDetails = () => {
  const navigate = useNavigate();

  const [list, setList] = useState([]);
  const [page, setPage] = useState(1);
  const [superAdmin, setSuperAdmin] = useState();
  const [pagination, setPagination] = useState("");
  const [amenity, setAmenity] = useState();
  const [loader, setLoader] = useState(false);
  const [popup, setPopup] = useState(false);
  const [addPopup, setAddPopup] = useState(false);
  const [type, setType] = useState();
  const [errors, setErrors] = useState(false);
  const inputRef = useRef(null);
  const [selectedImage, setSelectedImage] = useState(dummyimage);
  const [editId, setEditId] = useState(null);

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    setSelectedImage(event.target.files[0]);
  };
  const handleImageClick = () => {
    inputRef.current.click();
  };

  const handleStatus = async ({ id, status }) => {
    const formdata = new FormData();
    // formdata.append("type", 1);
    formdata.append("status", !status);

    try {
      const res = await post(`${URLS.MASTERURL}${id}/status/`, formdata);
      if (res?.status === "success") {
        toast.success(res?.message || "Status updated");
        fetch();
      }
    } catch (error) {
      console.error("Error updating status:", error);
      toast.error("Failed to update status");
    }
  };

  const fetch = async () => {
    try {
      const res = await get(`${URLS.MASTERURL}?type=${6}`);
      console.log("res banner home", res);
      setSelectedImage(res?.data[0]?.icon);
      setList(res?.results || res?.data || []);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchView = async (id) => {
    try {
      const res = await get(`${URLS.MASTERURL}${id}/`);
      console.log("res fetchView", res);
      setSelectedImage(res?.data?.icon);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetch();
    if (editId) fetchView(editId);
  }, [editId]);

  const handleSubmit = async () => {
    const formdata = new FormData();
    if (selectedImage && typeof selectedImage !== "string") {
      formdata.append("icon", selectedImage);
      console.log("formDataSSimage", selectedImage);
    }
    try {
      const res = await post(`${URLS.MASTERURL}${editId}/edit/`, formdata);
      console.log("res edit room category", res);

      setSelectedImage(null);
      if (res.status === "success") {
        toast.success(res.message || "Edited successfully");
        fetch();
        setSelectedImage("");
        setErrors(false);
        setAddPopup(false);
      }
    } catch (err) {
      console.log("err", err);
    }
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "S.No",
        Cell: ({ row }) => {
          const pageSize = 10;
          return <p className="red">{row.index + 1 + (page - 1) * pageSize}</p>;
        },
      },
      {
        Header: " Banner Image",
        accessor: "icon",
        Cell: ({ value, row }) => {
          return (
            <img src={value || dummyimage} alt="image" className="list-img" />
          );
        },
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value, row }) => {
          return (
            <div>
              <button
                onClick={() => {
                  if (checkPermission("CAN-STATUS-BANNER")) {
                    handleStatus(row.original);
                  }
                }}
                className={`${
                  value == false ? "deactive-btn" : "active-btn"
                } border-0  fs-sm-10 fs-md-12 fs-lg-14 fs-xl-13 fs-xxl-18`}
              >
                {value == false ? "De-active" : " Active"}
              </button>
            </div>
          );
        },
      },
      {
        Header: "Action",
        accessor: "",
        Cell: ({ value, row }) => {
          return (
            <React.Fragment>
              <div className="d-flex ac-js">
                {checkPermission("CAN-EDIT-BANNER") && (
                  <button
                    onClick={() => {
                      setAddPopup(true);
                      setType("edit");
                      setEditId(row.original.id);
                      fetchView(row.original.id);
                    }}
                    className="cust-btn "
                  >
                    <img src={edit_icon} alt="" className=" edit-btn " />
                  </button>
                )}
              </div>
            </React.Fragment>
          );
        },
      },
    ],
    [page]
  );

  return (
    <div>
      <Topbar header={"Master"} subHead={"Booking Deatils"} />
      <div className="d-flex ac-jb">
        {/* <h2 className=' f3 fs-sm-16 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26 '>Total:1</h2> */}
        <div className="d-flex gap-3">
          <div className="search-input">
            {/* <input
              //  onChange={(e) => (adminList(1, e.target.value))}
              type='text' placeholder='Search' style={{ border: 'none', width: '150px' }} />
            <img src={Search_icon} className='search' /> */}
          </div>
        </div>
      </div>
      <Table
        columns={columns}
        setPageno={setPage}
        pagecount={pagination}
        data={list}
        show={false}
      />
      {addPopup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <div className="d-flex ac-jb">
              <p className="f4 text-start  fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 ">
                {type == "add" ? "Add" : "Edit"}
              </p>
              <CloseSharpIcon
                onClick={() => {
                  setAddPopup(false);
                  setSelectedImage("");
                  setErrors("");
                  setAmenity("");
                }}
                className="pointer"
              />
            </div>
            <div className="d-flex ac-js mt-4">
              <div className="col-md-3">
                <div className=" mb-2 w-100 d-flex ac-jb">
                  <div
                    onClick={handleImageClick}
                    className="position-relative w-100"
                  >
                    <HighlightOffRoundedIcon className="img-cancel" />
                    <div className="d-flex ac-jb w-100">
                      <div>
                        {typeof selectedImage === "string" ? (
                          <img
                            alt="not found"
                            style={{
                              width: "100px",
                              height: "70px",
                            }}
                            src={selectedImage ? selectedImage : dummyimage}
                          />
                        ) : selectedImage?.name ? (
                          <img
                            alt="not found"
                            style={{
                              width: "100px",
                              height: "70px",
                            }}
                            src={URL.createObjectURL(selectedImage)}
                          />
                        ) : (
                          <img
                            alt="not found"
                            style={{
                              width: "100px",
                              height: "70px",
                            }}
                            src={dummyimage}
                          />
                        )}
                        <input
                          style={{
                            position: "absolute",
                            width: "100px",
                            height: "70px",
                            left: "0px",
                            top: "0px",
                          }}
                          type="file"
                          hidden
                          name="myImage"
                          accept="image/*"
                          ref={inputRef}
                          onChange={handleImageChange}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {selectedImage != "edit" && (
              <h4 className="f3 fs-sm-10 fs-md-10 fs-lg-11 fs-xl-12 fs-xxl-14 mt-2 text-start err ms-2">
                Max Upload Size : 5MB and Banner Size 1200px 700px*
              </h4>
            )}

            <div className="d-flex ac-jb px-2 mt-5">
              <button
                onClick={() => {
                  setAddPopup(false);
                  setSelectedImage("");
                  // logout();
                }}
                className="back-btn f2 w-40"
              >
                {/* {loading ? "Loading..." : "Confirm"} */}Cancel
              </button>
              <button
                onClick={() => {
                  handleSubmit();
                  // logout();
                }}
                className="submit-btn f2 w-40"
              >
                {/* {loading ? "Loading..." : "Confirm"} */}{" "}
                {type == "add" ? "Add" : "Submit"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BookingDetails;
